import { render, staticRenderFns } from "./AgregarEstudioDialogComponent.vue?vue&type=template&id=f1bbfa88&scoped=true"
import script from "./AgregarEstudioDialogComponent.vue?vue&type=script&lang=js"
export * from "./AgregarEstudioDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./AgregarEstudioDialogComponent.vue?vue&type=style&index=0&id=f1bbfa88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bbfa88",
  null
  
)

export default component.exports